import { render, staticRenderFns } from "./AccountPreferencesUpdate.container.vue?vue&type=template&id=3af6ff62&scoped=true&"
import script from "./AccountPreferencesUpdate.container.vue?vue&type=script&lang=ts&"
export * from "./AccountPreferencesUpdate.container.vue?vue&type=script&lang=ts&"
import style0 from "./AccountPreferencesUpdate.container.vue?vue&type=style&index=0&id=3af6ff62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af6ff62",
  null
  
)

export default component.exports